<!--  -->
<template>
  <div>
    <div class="browse" v-if="show">
      <img src="@/assets/img/components/browseTime/qixiaohang.png" alt="" />
      <div class="progress"><span :style="{ width: newPercent + '%' }"></span></div>
      <div class="time">
        <img
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/browse-bg.png"
          alt=""
        />
        <div>
          <p>{{ success ? '任务' : `浏览${baseTime}秒` }}</p>
          <p v-if="showMsg">{{ success ? '浏览完成' : `获取抽奖次数` }}</p>
        </div>
      </div>
      <DrawCardNumberPop :onNumberShow="onNumberShow" @showNumberFn="showNumberFn" />
    </div>
  </div>
</template>

<script>
import { searchUrl } from '@/utils/tools';
import { reqActivityDoneTask ,reqCircleDoneTask} from '@/api/collectCard/index';
import DrawCardNumberPop from './drawCardNumberPop.vue';

export default {
  components: {
    DrawCardNumberPop,
  },
  data() {
    return {
      baseTime: searchUrl('browseTime'),
      time: searchUrl('browseTime'),
      show: false,
      endTime: 0,
      success: false,
      onNumberShow: false,
      isApp: this.$root.isApp,
      miniprogram: this.$root.miniprogram,
      timer:null,
      showMsg:true
    };
  },
  computed: {
    newPercent() {
      const percent = (this.endTime / this.baseTime) * 100;
      return percent > 100 ? 100 : percent;
    },
  },
  watch: {
    $route() {
      this.getAnnexCap();
    },
  },
  methods: {
    showTask() {
      if (searchUrl('isBrowse') === '1') {
        this.show = true;
        this.timer = setInterval(() => {
          this.time = this.time - 1;
          this.endTime = this.endTime + 1;
          if (this.time === 0) {
            clearInterval(this.timer);
            // 打卡圈浏览任务
            if(searchUrl('sourceType')){
              this.getDoneTaskCircle()
            }else{
               this.getDoneTask();
            }
           
          }
        }, 1000);
      }
    },
    async getDoneTask() {
      const { code, msg } = await reqActivityDoneTask({
        cardActivityId: searchUrl('cardActivityId'),
        cardTaskId: searchUrl('cardTaskId'),
      });
      if (code === 0) {
        this.onNumberShow = true;
        this.success = true;
        if (this.isApp) {
          this.$sendToApp('reload', { mode: 1, url: '/ark/collectCardIndex' });
        }
      } else {
        this.$toast(msg);
      }
    },
    // 打卡圈任务
    async getDoneTaskCircle(){
      const { code, msg } = await reqCircleDoneTask({
        sourceType: 2,
      });
      if (code === 0) {
        this.$toast('浏览完成');
      } else {
        this.$toast(msg);
      }
    },
    showNumberFn(i) {
      this.onNumberShow = false;
      if (i === 1) {
        if(this.isApp){
           this.$sendToApp('closePage');
        }else{
         history.back()
        }

        this.show = false;
      }
    },
    getAnnexCap(){
      const isBrowse = searchUrl('isBrowse');
      if(isBrowse=='1'){
       this.showTask();
      }else{
        this.show=false
        clearInterval(this.timer);
      }
    }
  },
  created() {},
  mounted() {
    // this.showTask();
    this.showMsg=!searchUrl('sourceType')
  },
};
</script>
<style lang="scss" scoped>
.browse {
  position: fixed;
  top: 666px;
  right: 0;
  z-index: 9;
  width: 160px;
  > img {
    position: relative;
    top: 8px;
    z-index: 10;
    display: block;
    width: 98px;
    margin: 0 auto;
  }
  .progress {
    position: relative;
    width: 160px;
    height: 14px;
    background: #e0e0e0;
    border-radius: 12px;
    > span {
      position: absolute;
      left: 0;
      display: inline-block;
      width: 100px;
      height: 14px;
      background: #ffe800;
      border-radius: 12px;
    }
  }
  .time {
    // width: 160px;
    // height: 74px;
    // text-align: center;
    position: relative;
    img {
      width: 160px;
    }
    > div {
      position: absolute;
      top: 8px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 60px;
      span {
        display: inline-block;
        color: #fff;
        font-weight: 500;
        font-size: 18px;
      }
      p {
        width: 100%;
        padding-bottom: 4px;
        color: #fff;
        font-weight: 500;
        font-size: 18px;
        text-align: center;
      }
    }
  }
}
</style>
